import { RestClient } from '@affstore-ds/restclient'

import { TrackerTypesApiPaths, TrackerTypesOperations } from '../../types'

export const postApiTrackerAffiliateAction = (
  body: TrackerTypesOperations['PostApiTrackerAffiliateAction']['requestBody']['content']['application/json'],
  apiDomain: string,
) => {
  const client = new RestClient(TrackerTypesApiPaths.PostApiTrackerAffiliateAction, {}, apiDomain, {
    mode: 'cors',
    referrerPolicy: 'no-referrer',
  })

  return client.post('', body, { 'Content-Type': 'application/json' })
}
